import withCreateAdPartner from './withCreateAdPartner';
import { CreateAdPartner as View } from './View';

const CreateAdPartner = withCreateAdPartner(View);

export default CreateAdPartner;
